var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItemWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 8.10767C11.8232 8.10767 11.6798 8.25925 11.6798 8.44646V13.9532C11.6798 14.1404 11.8232 14.292 12.0003 14.292C12.1767 14.292 12.3201 14.1404 12.3201 13.9532V8.44646C12.3201 8.25926 12.1767 8.10767 12.0003 8.10767ZM12.0003 15.6702C11.8232 15.6702 11.6798 15.8218 11.6798 16.009V16.0098C11.6798 16.197 11.8232 16.3486 12.0003 16.3486C12.1767 16.3486 12.3201 16.197 12.3201 16.0098V16.009C12.3201 15.8218 12.1767 15.6702 12.0003 15.6702ZM12.0011 4.67756H12.0019C12.23 4.67756 12.429 4.81009 12.5341 5.00723L19.2758 17.3517C19.3283 17.4469 19.3589 17.5579 19.3589 17.6772C19.3589 18.0334 19.0854 18.3225 18.7476 18.3225L5.2524 18.3192C4.91461 18.3192 4.64109 18.0301 4.64109 17.6731C4.64109 17.5563 4.67087 17.4461 4.72259 17.3509L11.4666 5.00982C11.5708 4.81102 11.7715 4.67756 12.0011 4.67756ZM12.0011 4H12.0003C11.5379 4 11.1343 4.26589 10.9172 4.66017L4.16302 17.0212C4.05956 17.2133 4 17.4361 4 17.673C4 18.4044 4.56116 18.9967 5.25241 18.9967C5.25319 18.9967 18.7476 19 18.7476 19C19.4396 19 20 18.4077 20 17.6772C20 17.4361 19.9389 17.2108 19.8331 17.017L13.0726 4.63863C12.8532 4.25512 12.4549 4 12.0011 4Z",
    fill: "",
    stroke: "",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemWarningIcon);
export default __webpack_public_path__ + "static/media/item-warning-icon.b49eeeaeefa14f5eb43c686c63eb5660.svg";
export { ForwardRef as ReactComponent };